import React, { useState } from 'react';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import AdminList from '../component/admin/AdminList';
import AdminInvite from '../component/admin/AdminInvite';

const Admin = () => {
    const [selectedUser, setSelectedUser] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;

    const handleMoreOptionsClick = (user) => {
        setSelectedUser(user);
    };

    const handleEnableDisableUser = (action) => {
        console.log(`User ${selectedUser.Name} ${action}`);
        setSelectedUser(null);
    };

    return (
        <div className='w-full px-3 sm:px-4 lg:px-6 py-4 lg:py-6 bg-gradient-to-br from-gray-50 to-gray-100/50 min-h-screen mt-8 lg:mt-0'>
            {/* Page Header */}
            <div className='mb-6'>
                <div className='flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
                    <div>
                        <h1 className='text-2xl lg:text-3xl font-bold text-gray-800 flex items-center gap-2'>
                            <span>👤</span> Admin Management
                        </h1>
                        <p className='text-sm text-gray-500 mt-1'>
                            Manage administrators and their permissions
                        </p>
                    </div>
                    <div className='flex items-center gap-2 text-sm text-gray-500 bg-white px-4 py-2 rounded-xl shadow-sm'>
                        <span className='inline-block w-2 h-2 bg-green-500 rounded-full animate-pulse'></span>
                        Live Data
                    </div>
                </div>
            </div>

            {/* Admin Invite Section */}
            <div className='mb-6'>
                <AdminInvite />
            </div>

            {/* Admin List Section */}
            <div className='w-full'>
                <AdminList />
            </div>

            {/* Modal for enabling/disabling user */}
            {selectedUser && (
                <div className="fixed inset-0 flex items-center justify-end bg-black bg-opacity-50 z-50 pr-4 sm:pr-8 lg:pr-20">
                    <div className="bg-white rounded-2xl shadow-2xl p-6 w-64 animate-slideIn">
                        <div className="flex flex-col gap-2">
                            <h3 className="text-sm font-medium text-gray-500 mb-2">
                                Options for {selectedUser.Name}
                            </h3>
                            <button 
                                onClick={() => handleEnableDisableUser('enable')} 
                                className="flex items-center gap-3 px-4 py-3 text-green-600 hover:bg-green-50 rounded-xl transition-all duration-200 group"
                            >
                                <div className="p-2 bg-green-100 rounded-lg group-hover:bg-green-200 transition-colors">
                                    <TaskAltIcon className="text-green-600" />
                                </div>
                                <span className="font-medium">Enable User</span>
                            </button>
                            <button 
                                onClick={() => handleEnableDisableUser('disable')} 
                                className="flex items-center gap-3 px-4 py-3 text-red-600 hover:bg-red-50 rounded-xl transition-all duration-200 group"
                            >
                                <div className="p-2 bg-red-100 rounded-lg group-hover:bg-red-200 transition-colors">
                                    <CancelOutlinedIcon className="text-red-600" />
                                </div>
                                <span className="font-medium">Disable User</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Admin;